(ns web3.screens.sponsor
  (:require [web3.components.widgets :as widgets]
            [web3.components.drawer :as drawer]
            [web3.components.text :as text]
            [web3.routing.core :as routing]
            [web3.i18n :as i]
            [web3.view :as v]
            [web3.persistence.schema :as schema]
            [web3.forms.fields :as fields]
            [web3.utils :as utils]
            [reagent.core :as r]
            [web3.env :as env]
            [web3.persistence.current-property :as current-property]
            [web3.queries.root :as q-root]
            [web3.components.linkify :as linkify]))

(defn is-self-sponsor?
  []
  (let [sponsor-id (->> (current-property/get-property) :sponsors first :uuid)
        id (->> (q-root/me) :me :id)]
   (= sponsor-id id)))

(defn with-address [{:keys [personName companyName]
                     {person-image :link} :personImage
                     {company-image :link} :companyImage
                     :as sponsor}]
  [:div.flex.items-center
   {:style {:min-width 236
            :min-height 72}}
   (->> [person-image company-image]
        (keep utils/some-str)
        (map-indexed
         (fn [i src]
           (let [size 60]
             [:div.inline-block.flex-none.margin-right-2_5.pa2
              (merge
               nil
               {:key i})
              [:img
               (v/merge-props
                nil
                {:src src
                 :style {:width size
                         :height size
                         :object-fit "scale-down"
                         :margin-left (- (* i (/ size 2)))}})]]))))
   [:div
    [:div.text-size-11.text-uppercase (i/get :i/brought-to-you-by)]
    [:div.text-size-20.weight-medium {:key 1} personName]
    [:div.text-size-13.weight-medium {:key 2} companyName]]])

(defn actionable-sponsor
  "Show the current property, with arrow for chooser."
  [{:keys [href] :as props} sponsor]
  [(if href :a :div)
   (update props :class str "  text-black line-h-22 flex items-stretch cursor-pointer margin-v-2_5 hover-opacity-parent ")
   (with-address sponsor)
   (widgets/chevron-action {})])


(v/defview contact-information
  {:header {:title (i/get :i/contact-information)}}
  []
  (let [current-property (current-property/get-property)
        {:keys [mobilePhone officePhone email companyWebsite]
         :as sponsor} (first (:sponsors current-property))
        {:keys [referralLink]} (:me (q-root/me))
        {:keys [state]} (r/current-component)
        select! #(let [^js el (:input @state)
                       content-length (some-> referralLink (count))]
                   (doto el
                     (.focus)
                     (aset "selectionStart" 0)
                     (aset "selectionEnd" (+ 2 content-length))))
        copy! (fn []
                (select!)
                (let [copied? (js/document.execCommand "copy")]
                  (when copied?
                    (swap! state assoc :ephemeral-helptext "Copied")
                    (js/setTimeout #(swap! state dissoc :ephemeral-helptext)
                                   3000))))]
    [:div
     (interleave
      (keep identity [[:div.pad-all-3 {:key :name} (with-address sponsor)]
                      (when officePhone
                        [text/single-line-with-label {:key "officePhone"
                                                      :label "Office Phone"}
                         (schema/wrapped-phone-number officePhone)])
                      (when mobilePhone
                        [text/single-line-with-label {:key "mobilePhone"
                                                      :label "Mobile Phone"}
                         (schema/wrapped-phone-number mobilePhone)])
                      (when email
                        [text/single-line-with-label {:key "email"
                                                      :label "Email"}
                         [linkify/linkify email]])
                      (when companyWebsite
                        [text/single-line-with-label {:key "website"
                                                      :label "Website"}
                         [linkify/linkify companyWebsite]])
                      ])
      (map-indexed (fn [i x] (update x 1 assoc :key i)) (repeat drawer/drawer-list-spacer)))

     [:div.pad-all-3
      (when (is-self-sponsor?)
        [text/input {:ref #(when % (swap! state assoc :input %))
                     :on-click select!
                     :value referralLink
                     :encoding {:decode fields/decode-referral-link}
                     :ephemeral-helptext (:ephemeral-helptext @state)}]
        [widgets/black-button
         {:on-click copy!
          :class "margin-bottom-3 margin-top-4"}
         (i/get :i/copy-link)]
        [widgets/black-button
         {:class "margin-bottom-3 margin-top-4"
          :on-click #(routing/nav! (routing/path-for [:pro/start]))}
         (i/get :i/edit-pro-profile)])]]))
